import { render } from "./HausStep6.vue?vue&type=template&id=097bdfd2"
import script from "./HausStep6.vue?vue&type=script&lang=js"
export * from "./HausStep6.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__